import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CareItem } from 'src/replicant/care/care.ruleset';

export type CareActionType =
  | 'food'
  | 'snack'
  | 'toy'
  | 'firstAid'
  | 'bath'
  | 'toilet';

type CareAction = {
  type: CareActionType;
  item?: CareItem['id'];
};

const initialState = {
  currentCareAction: null as CareAction | null,
};

const { actions, reducer } = createSlice({
  name: 'care',

  initialState,

  reducers: {
    setCareAction(care, { payload }: PayloadAction<CareAction | null>) {
      care.currentCareAction = payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase('RESET_APP', () => initialState);
  },
});

export const careActions = actions;
export default reducer;
